"use client";

// External imports
import { useEffect, useState } from "react";

// Local imports
import CloseIcon from "@/app/assets/vectors/CloseIcon";
import classes from "./styles.module.css";
import languageConfig from "@/export/config";

export default function FeedbackToast() {
  const [showToast, setShowToast] = useState(0);

  const handleDismiss = () => {
    setShowToast(0);

    if (
      parseInt(
        localStorage.getItem(
          `fontsPage/isToastDismissed/${process.env.NEXT_PUBLIC_LANGUAGE}`
        ) || "0"
      ) > 0
    ) {
      setShowToast(0);

      localStorage.setItem(
        `fontsPage/isToastDismissed/${process.env.NEXT_PUBLIC_LANGUAGE}`,
        (
          parseInt(
            localStorage.getItem(
              `fontsPage/isToastDismissed/${process.env.NEXT_PUBLIC_LANGUAGE}`
            ) || "0"
          ) - 1
        ).toString()
      );
    }
  };

  useEffect(() => {
    if (
      !localStorage.getItem(
        `fontsPage/isToastDismissed/${process.env.NEXT_PUBLIC_LANGUAGE}`
      )
    ) {
      localStorage.setItem(
        `fontsPage/isToastDismissed/${process.env.NEXT_PUBLIC_LANGUAGE}`,
        "5"
      );
    }

    setTimeout(() => {
      setShowToast(
        parseInt(
          localStorage.getItem(
            `fontsPage/isToastDismissed/${process.env.NEXT_PUBLIC_LANGUAGE}`
          ) || "0"
        )
      );
    }, 5000);
  }, []);

  if (
    languageConfig?.globalComponents.footer.links.fontsFeedback &&
    showToast > 0
  ) {
    return (
      <div className={`${classes.toast}`}>
        <div className={`${classes.content}`}>
          <p>
            Can you help us improve the{" "}
            {languageConfig?.routes.fonts?.main.title} for you?
          </p>
          <a
            href={`${languageConfig?.globalComponents.footer.links.fontsFeedback}`}
            className={`${classes.link}`}
            target="_blank"
          >
            Share Feedback
          </a>
        </div>

        <button className={`${classes.closeButton}`} onClick={handleDismiss}>
          <CloseIcon />
        </button>
      </div>
    );
  } else {
    return null;
  }
}
